import { useSelector } from "react-redux";
import { consoleLog } from "./log-utils";
import { fetchUserDetails } from "../redux/slice/formUpdateSlice";
import React, { useEffect } from "react";

// const userRoleId = localStorage.getItem("userRoleId");


export const useGetUserRoleId=()=>{
  let userDetails=useSelector(fetchUserDetails)
  consoleLog("userRoleId///////////////////",userDetails)
  return userDetails.userRoleId;
}

// export const useGetUserRoleId = () => {
//   const userDetails = useSelector((store)=>{return store.rootReducer.formUpdateReducer.userRoleId});

//   // Save to localStorage only once when available
//   console.log("user role id",userDetails!=""?userDetails : localStorage.getItem("userRoleId"))
//   return userDetails!=""?userDetails : localStorage.getItem("userRoleId");
// };

export function useIsDsplayAddProduct() {
  let userId=useGetUserRoleId();
  let userRoleId=userId!==""?userId:localStorage.getItem("userRoleId")
  if (userRoleId === "1" || userRoleId === "2" || userRoleId === "3")
    return true;
  return false;
}

export function useIsStoreLogin() {
 
  let userId=useGetUserRoleId();
  let userRoleId=userId!==""?userId:localStorage.getItem("userRoleId")
  if (userRoleId === "4" || userRoleId === "8") return true;

  return false;
}

export function useIsFranchisLogin() {
  
  let userId=useGetUserRoleId();
  let userRoleId=userId!==""?userId:localStorage.getItem("userRoleId")

  if (userRoleId === "9") return true;
  return false;
}

export function useIsCms(){
  let userId=useGetUserRoleId();
  let userRoleId=userId!==""?userId:localStorage.getItem("userRoleId")
  if(userRoleId==="10")return true;
  return false
}

export function useIsEmployee(){
  
  let userId=useGetUserRoleId();
  let userRoleId=userId!==""?userId:localStorage.getItem("userRoleId")  
  if(userRoleId==="3")return true;
  return false
}

export function useIsSuperAdmin(){
  let userId=useGetUserRoleId();
  let userRoleId=userId!==""?userId:localStorage.getItem("userRoleId")
  if(userRoleId==="1")return true;
  return false
}
export function useIsAdmin(){
  let userId=useGetUserRoleId();
  let userRoleId=userId!==""?userId:localStorage.getItem("userRoleId")  
  if(userRoleId==="2")return true;
  return false
}
export function useCanCreateUser(){
  let userId=useGetUserRoleId();
  let userRoleId=userId!==""?userId:localStorage.getItem("userRoleId")
  if(userRoleId==="1" ||userRoleId==="2")return true;
  return false
}
export function useIsCustomerSupport(){
  let userId=useGetUserRoleId();
  let userRoleId=userId!==""?userId:localStorage.getItem("userRoleId")  
  if(userRoleId==="6")return true;
  return false
}

export function useIsDsplayCrud() {
  let userId=useGetUserRoleId();
  let userRoleId=userId!==""?userId:localStorage.getItem("userRoleId")  
  if (userRoleId === "1") return true;
  return false;
}
export function useIsAccountent(){
  let userId=useGetUserRoleId();
  let userRoleId=userId!==""?userId:localStorage.getItem("userRoleId")  
  if(userRoleId==="11")return true;
  return false
}

export function useIsMarketingExcutive(){
  let userId=useGetUserRoleId();
  let userRoleId=userId!=""?userId:localStorage.getItem("userRoleId")  
  if(userRoleId==="3")return true;
  return false
}